<template>
  <div>
    <!-- 扫描工具APP -->
    <el-tabs v-model="activeName" type="card">
    <el-tab-pane style="padding: 20px;" :label="$t('messageAdd.scanTool.001')" name="first">
        <barcodeSet :scanToolDataNoFilter="scanToolDataNoFilter" 
        @handleGrandChildEvent="handleGrandChildEvent"
        @handleGrandChildEventFilter="handleGrandChildEventFilter"
        ></barcodeSet>
    </el-tab-pane>
    <el-tab-pane style="padding: 20px;" :label="$t('messageAdd.scanTool.002')" name="second">
       <AppSet :appSettingDataNoFilter="appSettingDataNoFilter"
       @handleAppSetNoFilter="handleAppSetNoFilter"
       @handleAppSetFilter="handleAppSetFilter"
       ref="appSet"
       ></AppSet>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>
<script>
import barcodeSet from '@/views/menuPage/ScanToolComponents/BarcodeSettings.vue';
import AppSet from '@/views/menuPage/ScanToolComponents/ApplicationSetting.vue';
export default {
  props:{
    scanToolDataNoFilter:{
      type:Object
    },
    appSettingDataNoFilter:{
      type:Object
    },
    deleteAllAppData:{
      type:Boolean
    }
  },
  data() {
    return {
      activeName: "first",
    };
  },
  components:{
    barcodeSet,
    AppSet
  },
  watch:{
     // deleteAllAppData prop
     deleteAllAppData(newVal) {
      if (newVal === true) {
        this.$refs.appSet.clearAllData();
        this.$emit('allChildAppDataDeleted');
      }
    }
  },
  methods: {
    // 将条码设置数据传给父组件
    handleGrandChildEvent(data){
      this.$emit('update:scanToolDataNoFilter',data)
      this.$emit('update:config-scanToolDataNoFilter',data)
    },
    // 过滤的条码值
    handleGrandChildEventFilter(data){
      this.$emit('update:scanToolDataFilter',data)
      this.$emit('update:config-scanToolDataFilter',data)
    },
    // 未过滤应用设置值
    handleAppSetNoFilter(data){
      this.$emit('update:appSettingDataNoFilter',data)
      this.$emit('update:config-appSettingDataNoFilter',data)
    },
    // 已过滤应用设置值
    handleAppSetFilter(data){
      this.$emit('update:appSettingDataFilter',data)
      this.$emit('update:config-appSettingDataFilter',data)
    },
    // app设置数据清空
 
  },
};
</script>
